export default "__VITE_ASSET__Qmu793Jw__"